export default {
    PROCESS_RES: (state, data) => {
        state.items = data.items.map(i => ({...i, margin: (parseFloat(i.margin) * 100).toFixed(2)}));
        state.pagination = {
            page: data.page || 1,
            totalPages: data.totalPages || 1,
            count: data.count || 0
        };
    },
    SET_ALL_ITEMS: (state, items) => {
        state.allItems = items;
    }
};
